export const config = {
  redirectAfterLogin: true,
};
